<template>
  <Carousel class="relative flex items-center justify-center" :opts="carouselOptions">
    <CarouselContent>
      <CarouselItem v-for="image in images" :key="image">
        <div class="w-full">
          <img
            class="h-full max-h-[calc(100dvh-5.25rem)] w-full select-none object-contain"
            :src="renderImage(image, 1000)"
            :alt="image"
          />
        </div>
      </CarouselItem>
    </CarouselContent>
    <CarouselPagination class="absolute bottom-2 z-10" @click.stop />
  </Carousel>
</template>

<script setup lang="ts">
import { Carousel, CarouselContent, CarouselItem, CarouselPagination } from '@ui/carousel';

import { renderImage } from '@helpers/cloudinary';

interface CarouselProps {
  images: Array<string>;
}

withDefaults(defineProps<CarouselProps>(), {
  images: () => [],
});

const carouselOptions = {
  loop: true,
  align: 'center' as const,
  dragFree: false,
  containScroll: 'trimSnaps' as const,
  slidesToScroll: 1,
  skipSnaps: false,
  watchDrag: true,
  watchResize: true,
  watchSlides: true,
};
</script>
